<template>
    <v-container fluid>
        <v-row class="mt-6 ml-3">
            <h1>個案代號: {{patient_code}}</h1>
        </v-row>
        <!--<v-row v-for="(row0, idx) in rows0" :key="idx" class="pa-6">-->
        <v-row v-for="idx in Math.ceil(rows0.length / 2)" :key="idx" class="pa-6">
            <v-col cols="6" v-for="(row0, innerIdx) in rows0.slice((idx - 1) * 2, idx * 2)">
              <span v-if="row0.split('//__//')[0] == 1">
                <h3>{{row0.replace('1//__//', '')}}</h3>
                <ul>
                  <li v-for="(ans, ansIdx) in ans_dict[(idx - 1) * 2 + innerIdx + 1]" :key="ansIdx">{{dateRows[ansIdx]}} => {{ans}}</li>
                </ul>
              </span>
              <span v-else-if="row0.split('//__//')[0] == 2">
                <h3>{{row0.replace('2//__//', '')}}</h3>
                <ul>
                  <li v-for="(ans, ansIdx) in ans_dict[(idx - 1) * 2 + innerIdx + 1]" :key="ansIdx">{{dateRows[ansIdx]}} => {{ans}}</li>
                </ul>
              </span>
              <span v-else-if="row0.split('//__//')[0] == 3">
                <h3>{{row0.replace('3//__//', '')}}</h3><line-chart :dataset="ans_dict[(idx - 1) * 2 + innerIdx + 1]" :dateset="dateRows" :i="(idx - 1) * 2 + innerIdx + 1"></line-chart>
              </span>
              <span v-else-if="row0.split('//__//')[0] == 4">
                <h3>{{row0.replace('4//__//', '')}}</h3>
                <ul>
                  <li v-for="(ans, ansIdx) in ans_dict[(idx - 1) * 2 + innerIdx + 1]" :key="ansIdx">{{dateRows[ansIdx]}} => {{ans}}</li>
                </ul>
              </span>
              <span v-else-if="row0.split('//__//')[0] == 5">
                <h3>{{row0.replace('5//__//', '')}}</h3>
                <ul>
                  <li v-for="(ans, ansIdx) in ans_dict[(idx - 1) * 2 + innerIdx + 1]" :key="ansIdx">{{dateRows[ansIdx]}} => {{ans}}</li>
                </ul>
              </span>
            </v-col>
        </v-row>



    </v-container>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

import Choice from '../materials/question_user/Choice'
import Essay from '../materials/question_user/Essay'
import Matrix from '../materials/question_user/Matrix'
import Multiplechoice from '../materials/question_user/Multiplechoice'
import Choicewithtext from '../materials/question_user/Choicewithtext'

export default {
    components: {
      Choice, Essay, Matrix, Multiplechoice, Choicewithtext,
      'line-chart':{
        extends: VueChartJs.Line,
        props: {
            dateset: {
                type: Array,
                default: ()=>[],
            },
            dataset: {
                type: Array,
                default: ()=>[],
            }
        },
        mounted () {

          this.renderChart({
            labels: this.dateset,
            datasets: [
              {
                label: '',
                backgroundColor: '#29b2d9',//'#f87979',
                fill: false,
                lineTension: 0,
                data: this.dataset
              }
            ]
          }, {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        responsive: true,
                        mainAspectRatio: false,
                        callback: (v) => !!~[0, 1, 2, 3, 4, 5].indexOf(v) ? v : '',
                        min: 0,
                        max: 5,
                        step: 1,
                        stepSize: 1,
                    }
                }]
            }
          })
        }
      }
    },
    data(){
        return {
            survey_id: -1,
            survey_participant_id: '',
            patient_code: '',
            question_list: [],
            ans_dict: {},
            doctor_id: -1,
            account_type: parseInt(localStorage.getItem('account_type')),
            rows: [],
            rows0: [],
            dateRows: [],
        }
    },
    created(){
        let check = 's' in this.$route.query && 'i' in this.$route.query && 'u' in this.$route.query
        if(check == false) {
            bus.$emit('alert', {msg: "操作異常", title: "提示",　check: "我知道了"})
            this.$router.push('/question_overview')
        }
        if('d' in this.$route.query){
            this.doctor_id = this.$route.query.d
        }
        this.survey_id = this.$route.query.s
        this.survey_participant_id = this.$route.query.i
        // this.patient_code = this.$route.query.u

        this.getSurveys()



    },
    methods: {
        getSurveys(){
            let post_data = {'survey_id':this.survey_id,
                             'doctor_id': this.doctor_id,
                             'survey_participant_id': this.survey_participant_id,}
            //axios.post(host_url+'survey_report/', post_data, {responseType: 'blob'})
            axios.post(host_url+'survey_report/', post_data, {responseType: 'json'})
            .then(response => {
                var data = response.data
                this.patient_code = data.rows[0][0];

                for (var i = 0; i < data.rows0.length; i++) {
                  this.ans_dict[i] = [];
                }

                for (var i = 0; i < data.rows.length; i++) {
                  var row = data.rows[i];
                  for (var j = 0; j < row.length; j++) {
                    this.ans_dict[j].push(row[j]);
                  }
                }

                for (var i = 0; i < data.rows.length; i++) {
                  this.rows[i] = data.rows[i].slice(1);
                }
                this.rows0 = data.rows0.slice(1);
                this.dateRows = data.dateRows;
                for (var i = 0; i < data.dateRows.length; i++) {
                  var newDate = new Date(data.dateRows[i]);
                  if(newDate.getMinutes()<10 && newDate.getHours()<10)
                      newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":0"+newDate.getMinutes()
                  else if(newDate.getMinutes()<10)
                      newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":0"+newDate.getMinutes()
                  else if(newDate.getHours()<10)
                      newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":"+newDate.getMinutes()
                  else
                      newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":"+newDate.getMinutes()
                  this.dateRows[i] = newDate;
                }
                return;
            })
            .catch((error)=> {
                console.log(error);
            });
        },
    },
}
</script>
